import React from "react";
import { useTranslation } from "react-i18next";
import { FaCog } from "react-icons/fa";
import { FaSearch, FaUserPlus, FaUserCog } from "react-icons/fa";

const FriendListTitleTemplate = ({ handleSelectedFunc, handleSelectedAudioInfo, selectedFunc, countRecommendFriends }) => {
    const { t } = useTranslation();

    const addFriends = () => {
        if (selectedFunc === "ADD" || selectedFunc === "RECOMMEND" || selectedFunc === "KEYWORD_TOGGLE" || selectedFunc === "ID_TOGGLE") {
            selectedFunc = "NONE";
        } else {
            selectedFunc = "ADD";
        }
        handleSelectedFunc({ selectedFunc: selectedFunc });
    }

    const searchFriends = () => {
        if (selectedFunc === "SEARCH_TOGGLE") {
            selectedFunc = "NONE";
        } else {
            selectedFunc = "SEARCH_TOGGLE";
        }
        handleSelectedFunc({ selectedFunc: selectedFunc });
    }

    const editFriendsList = () => {
        if (selectedFunc === "EDIT") {
            selectedFunc = "NONE";
        } else {
            selectedFunc = "EDIT";
        }
        handleSelectedFunc({ selectedFunc: selectedFunc });
    }

    const configAudioSpeakerDevice = () => {
        handleSelectedAudioInfo({ selectedFunc: "OPEN_SOUND_SETTING" });
    }

    return (
        <div className="title-area main justify-content-between white-text" style={{ backgroundColor: '#2874ff' }}>
            <b>{t("내_정보", { ns: "user" })}</b>
            <div className="func-area right">
                { // sound control mode 가 아니어도 음향 기기 설정 버튼이 보이도록 수정 by hjkim 20230503
                    // viewCMD === remoconType.SoundControl &&
                    <button type="button" title={t("음향_기기_설정", { ns: "hiclasstv" })} onClick={configAudioSpeakerDevice}>
                        <FaCog className="d-flex font-md white-text" />
                    </button>
                }
            </div>
            {/* <b>{t("친구", { ns: "friend" })}</b>
            <div className="func-area">
                <button type="button" className={(selectedFunc === "SEARCH_TOGGLE" ? "select" : "")} title={t("검색", { ns: "common" })} onClick={searchFriends}>
                    <FaSearch className="d-flex font-md white-text" />
                </button>
                <button type="button" className={(selectedFunc === "ADD" || selectedFunc === "RECOMMEND" || selectedFunc === "KEYWORD_TOGGLE" || selectedFunc === "ID_TOGGLE" ? " select" : "")} style={{ position: 'relative' }} title={t("친구_추가", { ns: "friend" })} onClick={addFriends}>
                    <FaUserPlus className="d-flex font-md white-text" />
                    {
                        countRecommendFriends > 0 &&
                        <span className="count">N</span>
                    }
                </button>
                <button type="button" className={(selectedFunc === "EDIT" ? " select" : "")} title={t("친구_관리", { ns: "friend" })} onClick={editFriendsList}>
                    <FaUserCog className="d-flex font-md white-text" />
                </button>
            </div> */}
        </div>
    );
}

export default FriendListTitleTemplate;